export default "__VITE_ASSET__Xwi0QncK__"